module.exports = __webpack_public_path__ + "img/p10.0625522a.png";